import { render, staticRenderFns } from "./benefitReports.vue?vue&type=template&id=5629f94f&scoped=true"
import script from "./benefitReports.vue?vue&type=script&lang=js"
export * from "./benefitReports.vue?vue&type=script&lang=js"
import style0 from "./benefitReports.vue?vue&type=style&index=0&id=5629f94f&prod&scoped=true&lang=css"
import style1 from "./benefitReports.vue?vue&type=style&index=1&id=5629f94f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629f94f",
  null
  
)

export default component.exports